var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "top-bar" },
        [
          _c(
            "transition",
            { attrs: { name: "fade-spoiler", mode: "out-in" } },
            [
              _vm.isHidden
                ? _c("div", {
                    key: "spoiler",
                    staticClass: "top-bar__spoiler",
                    style: _vm.spoilerForeground,
                    on: { click: _vm.onClick }
                  })
                : _c(
                    "a",
                    {
                      key: "content",
                      staticClass: "top-bar__content",
                      style: _vm.contentForeground,
                      attrs: { target: _vm.banner.target, href: _vm.banner.url }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "top-bar__close",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.close($event)
                            }
                          }
                        },
                        [
                          _c("f-sprite-icon", {
                            attrs: {
                              "icon-link": _vm.$options.icons.IconClose.id
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }